export enum MultiSelectSearchTypes {
  'WORK_ORDER' = 1,
  'INVERTER' = 2,
  'TYPE3' = 3,
  'POWERLINE' = 4,
}

export enum MultiSelectSearchModes {
  'REPORTED_CURRENT' = 'reported_current',
  'REPORTED_ANY' = 'reported_any',
  'REPORTED_CURRENT_NOT' = 'reported_current_not',
  'REPORTED_ANY_NOT' = 'reported_any_not',
}
